import React from 'react'

export const DashboardContext = React.createContext({
  snackbar: {},
  openSnackbar: () => {},
  closeSnackbar: () => {},
  filterGroupID: 0,
  setFilterGroupID: () => {},
  clientsTrainerID: '',
  setClientsTrainerID: () => {},
  clientSearch: {},
  setClientSearch: () => {},
  teamSearch: {},
  setTeamSearch: () => {},

  showMessages: false,
  setShowMessages: () => {},
  messageChannel: {},
  setMessageChannel: () => {},
  channelFilter: '',
  setChannelFilter: () => {}
});